import PropTypes from "prop-types";
import React, { useMemo } from "react";

import { Typography, Box, useMediaQuery, useTheme } from "@material-ui/core";

ShowMoreText.propTypes = {
  lines: PropTypes.number,
  text: PropTypes.node,
};

export default function ShowMoreText({lines = "5", text }) {
  const theme = useTheme();
  const matchesAdaptive = useMediaQuery(theme.breakpoints.down("lg"));

  const [expanded, setExpand] = React.useState(false);

  function handleClick() {
    setExpand(!expanded);
  }

  const styles = useMemo(() => ({
    default: {
      "-webkit-line-clamp": expanded ? "unset" : lines,
      "line-clamp": expanded ? "unset" : lines,
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkit-box-orient": "vertical",
      overflow: "hidden",
      textAlign: "left",
    },
  }), [expanded, lines]);

  return (
    <>
      <Typography
        sx={matchesAdaptive ? styles.default: {}}
        variant="inherit"
      >
        {text}
      </Typography>

      {matchesAdaptive && (
        !expanded ? (
          <Box
            alignItems="center"
              css={{ cursor: "pointer" }}
            display={{ xs: "flex", lg: "none" }}
            onClick={handleClick}
            role="button"
            >
            <Typography color="primary.main" mt={2} textAlign="center" variant="subtitle2">
              Подробнее
            </Typography>
          </Box>
        ) : (
          <Box
            alignItems="center"
            css={{ cursor: "pointer" }}
            display={{ xs: "flex", lg: "none" }}
            onClick={handleClick}
            role="button"
          >
            <Typography color="primary.main" mt={2} textAlign="center" variant="subtitle2">
              Скрыть
            </Typography>
          </Box>
        )
      )}
    </>
  );
}
